import { useState } from "react";
import Swal from "sweetalert2";
import { AddAddressService } from "../../../services/MainScreen";
import { setAddressIdCookie } from "../../../utility/Cookies";

export default function AddAddressComponent({
  setAddresses,
  setSetselectdAddressId,
}) {
  const [formData, setFormData] = useState({
    address: "",
    city: "",
    state: "",
    postal_code: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const errors = {};
    if (!formData.address) errors.address = "آدرس را بنویسید";
    if (!formData.city) errors.city = "شهر را بنویسید";
    if (!formData.state) errors.state = "استان را بنویسید";
    if (!formData.postal_code) {
      errors.postal_code = "کد پستی را بنویسید";
    } else if (!/^\d{10}$/.test(formData.postal_code)) {
      errors.postal_code = "کد پستی باید ۱۰ رقم باشد";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddAddresses = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (validateForm()) {
      const result = await AddAddressService(
        formData.address,
        formData.city,
        formData.state,
        formData.postal_code
      );

      if (result.status === 200) {
        setAddressIdCookie(result.result.id);
        setAddresses((prevAddresses) => [...prevAddresses, result.result]);
        setSetselectdAddressId(result.result.id);
        setFormData({
          address: "",
          city: "",
          state: "",
          postal_code: "",
        });
      } else if (result.status === 400) {
        Swal.fire({
          icon: "error",
          title: result.message,
          html: `${
            result.result?.postal_code
              ? "کد پستی : " + result.result?.postal_code
              : ""
          }<br/>${
            result.result?.address ? "آدرس: " + result.result?.address : ""
          } <br/>${
            result.result?.state ? "استان: " + result.result?.state : ""
          } <br/> ${result.result?.city ? "شهر : " + result.result?.city : ""}`,
          confirmButtonText: "باشه",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "خطا!",
          text: "در هنگام ارتباط با سرور به مشکل خوردید!",
          confirmButtonText: "باشه",
        });
      }
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleAddAddresses}>
      <div className="row form-group cart-checkout-zipcode">
        <label
          className="col-form-label col-md-3 text-md-left cart-checkout-zipcode-label"
          for="state"
        >
          استان
        </label>
        <div className="col-md-9 col-lg-6">
          <input
            type="text"
            name="state"
            className="form-control cart-checkout-zipcode-input"
            value={formData.state}
            onChange={handleInputChange}
          />
          {errors.state && (
            <div className="validation-inline cart-checkout-inline-error text-danger">
              <span>{errors.state}</span>
            </div>
          )}
        </div>
      </div>

      <div className="row form-group cart-checkout-zipcode">
        <label
          className="col-form-label col-md-3 text-md-left cart-checkout-zipcode-label"
          for="city"
        >
          شهر
        </label>
        <div className="col-md-9 col-lg-6">
          <input
            type="text"
            name="city"
            className="form-control cart-checkout-zipcode-input"
            value={formData.city}
            onChange={handleInputChange}
          />
          {errors.city && (
            <div className="validation-inline cart-checkout-inline-error text-danger">
              <span>{errors.city}</span>
            </div>
          )}
        </div>
      </div>

      <div className="row form-group cart-checkout-zipcode">
        <label
          className="col-form-label col-md-3 text-md-left cart-checkout-zipcode-label"
          for="postal_code"
        >
          کد پستی
        </label>
        <div className="col-md-9 col-lg-6">
          <input
            type="text"
            name="postal_code"
            className="form-control cart-checkout-zipcode-input"
            value={formData.postal_code}
            onChange={handleInputChange}
          />
          {errors.postal_code && (
            <div className="validation-inline cart-checkout-inline-error text-danger">
              <span>{errors.postal_code}</span>
            </div>
          )}
        </div>
      </div>

      <div className="row form-group cart-checkout-zipcode">
        <label
          className="col-form-label col-md-3 text-md-left cart-checkout-zipcode-label"
          for="address"
        >
          آدرس
        </label>
        <div className="col-md-9 col-lg-6">
          <input
            type="text"
            name="address"
            className="form-control cart-checkout-zipcode-input"
            value={formData.address}
            onChange={handleInputChange}
          />
          {errors.address && (
            <div className="validation-inline cart-checkout-inline-error text-danger">
              <span>{errors.address}</span>
            </div>
          )}
        </div>
      </div>

      <div className="row form-group signin-rememberme mt-20">
        <div className="col-12 col-md-6 mt-2"></div>
        <div className="col-12 col-md-6 mt-2">
          <button
            type="submit"
            className="btn btn-lg btn-primary signin-submit shadow"
            style={{ padding: "0.4625rem 1.1875rem" }}
          >
            {loading ? (
              <i className={"fa fa-fw fa-refresh fa-spin "} />
            ) : (
              "افزودن"
            )}
          </button>
        </div>
      </div>
    </form>
  );
}
